import { getLanguageByShortcut } from '@utils/language.utils';
import { supportLanguages } from './app.component';
import { TranslateService } from '@ngx-translate/core';
import { Injector } from '@angular/core';
import { AuthService } from './features/authentication/services/auth.service';
import { LOCATION_INITIALIZED } from '@angular/common';
import { FeatureToggleService } from '@core/feature-toggle/feature-toggle.service';
import { FeatureEnum } from '@core/feature-toggle/feature.enum';
import { map, mergeMap } from 'rxjs/operators';
import { from, lastValueFrom } from 'rxjs';
import { LanguageService } from '@shared/services/localisation/language.service';
import { maintenancePageRoute } from '@utils/routing.utils';

export function initAuth(authService: AuthService, translateService: TranslateService, injector: Injector): () => Promise<boolean> {
  return () => {
    if (window.location.pathname.startsWith(`/${maintenancePageRoute}`)) {
      return lastValueFrom(from(setupLocalisation(translateService, injector)).pipe(map(() => false)));
    }

    return lastValueFrom(
      authService
        .checkAuthentication()
        .pipe(mergeMap(isAuthenticated => from(setupLocalisation(translateService, injector)).pipe(map(() => isAuthenticated))))
    );
  };
}

export function setupLocalisation(translateService: TranslateService, injector: Injector) {
  return new Promise<any>((resolve: any) => {
    let locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
    locationInitialized.then(() => {
      translateService.addLangs(supportLanguages);
      const defaultLang = getLanguageByShortcut(translateService.getBrowserLang());
      const lang = defaultLang && supportLanguages.includes(defaultLang.name) ? defaultLang.name : 'English';
      translateService.setFallbackLang(lang);

      translateService.use(lang).subscribe({
        complete: () => {
          const languageService = injector.get(LanguageService);
          languageService.initialize(lang);
          resolve(null);
        }
      });
    });
  });
}

export function initFeatureToggles(featureToggleService: FeatureToggleService): () => Promise<FeatureEnum[]> {
  return () => featureToggleService.initFeatureToggles();
}
